export default __webpack_public_path__ + "static/media/thomas_g.ede02182.png";